export enum SecureApplicationReasonEnum {
  unknown,
  pwa,
  authenticated,
  jointMaintenance,
  resume
}
